"use client";

import { NativeSelect } from "@chakra-ui/react";

const size = "md";
const getVal = (items) => {
  let res = "";
  if (items?.forEach) {
    items.forEach((a) => {
      if (a.selected === true) {
        // { key: 1, label: "React.js", value: "react" },
        res = a?.value;
        return;
      }
    });
  }
  return res;
};

const DropDown = ({ onChange, items, style, w, disabled, placeholder }) => {
  // const [value, setValue] = useState();

  const handleValueChnage = (v) => {
    let list = [];
    let item;
    if (items?.map) {
      list = items.map((a) => {
        a.selected = false;
        if (a.value === v) {
          a.selected = true;
          item = a;
        }
        return a;
      });
    }
    onChange && onChange({ list, item });
  };

  // useEffect(() => {
  //   // if (items?.length && items.length === 1) {
  //   //   setValue(items[0].value);
  //   // } else
  // }, [items]);

  return (
    <NativeSelect.Root size={size} width={w || "240px"}>
      <NativeSelect.Field
        disabled={disabled || false}
        // placeholder={placeholder || "select option"}
        onChange={(e) => handleValueChnage(e.currentTarget.value)}
        value={getVal(items)}
      >
        <option value="" disabled hidden>
          {placeholder || "Select option"}
        </option>

        {items?.map &&
          items.map((item, index) => (
            <option key={item.key} value={item.value}>
              {item.label}
            </option>
          ))}
      </NativeSelect.Field>
      <NativeSelect.Indicator />
    </NativeSelect.Root>
  );
};

export default DropDown;
